import React from 'react';


const CookiesSettings = () => (
  <div className="content">
    <div className="container">
      <h1 className="h3">How to Manage Cookies</h1>
      <div className="well">
        <p>
          As we explain in our{' '}
          <a href="/cookie-policy">Cookie Policy</a>,
          cookies help you to get the most out of our
          websites. If you do disable our cookies you may
          find that certain sections of our websites do
          not work.
        </p>
        <p className="h4">
          How to disable behaviorally&nbsp;targeted
          advertising cookies
        </p>
        <p>
          If you are concerned about behaviorally targeted
          advertising cookies (which serve you
          advertisements based on your use of our
          websites), users based in the European Union can
          visit{' '}
          <a
            href="https://www.youronlinechoices.eu"
            rel="noopener noreferrer"
            target="_blank"
          >
            www.youronlinechoices.eu
          </a>{' '}
          and users based in the US can visit{' '}
          <a
            href="http://www.aboutads.info/choices"
            rel="noopener noreferrer"
            target="_blank"
          >
            www.aboutads.info/choices
          </a>{' '}
          to opt out of these third-party cookies.
        </p>
        <p>
          The above websites are not SK sites and we are
          not responsible for their content.
        </p>
        <p className="h4">
          How to enable and disable cookies using your
          browser
        </p>
        <p>
          Most browsers allow you to manage cookie
          settings. These settings can usually be found in
          the 'Settings', 'Options' or 'Preferences' menu
          of your browser. The links below are provided to
          help you find the settings for some common
          browsers.
        </p>
        <ul>
          <li>
            Manage cookie settings in{' '}
            <a
              href="https://support.google.com/chrome/answer/95647?hl=en"
              rel="noopener noreferrer"
              target="_blank"
            >
              Chrome
            </a>{' '}
            and{' '}
            <a
              href="https://support.google.com/chrome/answer/95647?hl=en&amp;co=GENIE.Platform%3DAndroid&amp;oco=1"
              rel="noopener noreferrer"
              target="_blank"
            >
              Chrome Android
            </a>{' '}
            and{' '}
            <a
              href="https://support.google.com/chrome/answer/95647?hl=en&amp;co=GENIE.Platform%3DiOS&amp;oco=1"
              rel="noopener noreferrer"
              target="_blank"
            >
              Chrome iOS
            </a>
          </li>
          <li>
            Manage cookie settings in{' '}
            <a
              href="https://support.apple.com/kb/PH19214?locale=en_US"
              rel="noopener noreferrer"
              target="_blank"
            >
              Safari
            </a>{' '}
            and{' '}
            <a
              href="https://support.apple.com/en-gb/HT201265"
              rel="noopener noreferrer"
              target="_blank"
            >
              Safari iOS
            </a>
          </li>
          <li>
            Manage cookie settings in{' '}
            <a
              href="https://support.mozilla.org/kb/enable-and-disable-cookies-website-preferences"
              rel="noopener noreferrer"
              target="_blank"
            >
              Firefox
            </a>
          </li>
          <li>
            Manage cookie settings in{' '}
            <a
              href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
              rel="noopener noreferrer"
              target="_blank"
            >
              Internet Explorer
            </a>
          </li>
          <li>
            Manage cookie settings in{' '}
            <a
              href="http://www.opera.com/help/tutorials/security/privacy"
              rel="noopener noreferrer"
              target="_blank"
            >
              Opera
            </a>
          </li>
        </ul>
        <p>
          For all other browsers, please look for a "help"
          function in your browser or contact the browser
          provider.
        </p>
      </div>
    </div>
  </div>
);

export default CookiesSettings;
